/* HTTP service */

import axios from "axios";
import Settings from "./settings.service";
import Storage from "./storage.service";
import { handleError } from "./errors.service";
import { loginByDeviceID } from "./user.service";
let device = Math.floor(Math.random() * 10000000000 + 1); //Helpers.generateDeviceID();

let session_id = "";
let qualified_session_id = "";

const HTTP = axios.create({
	baseURL: Settings.base_url,
	headers: {
		"accept-version": Settings.api_version,
		"Virgin-Lang": "en",
		ChannelID: "Web",
		"Channel-Id": "Web",
		"Virgin-Device-Id": device,
		"Virgin-Device-Os": "Web",
	},
});

const HTTP_other = axios.create();

HTTP.defaults.headers.common["Accept"] = "application/json";

HTTP.defaults.headers.post["Content-Type"] =
	"application/x-www-form-urlencoded";

HTTP.interceptors.request.use(
	(config) => {
		if (config.baseURL === Settings.base_url) {
			config.headers["Virgin-Device-Id"] = device;

			if (qualified_session_id) {
				config.headers["Session-Id"] = qualified_session_id;
			} else {
				if (session_id) {
					config.headers["Session-Id"] = session_id;
				}
			}
		}
		return config;
	},
	(error) => {
		Promise.reject(error);
	}
);

HTTP.interceptors.response.use(null, (error) => {
	// let url = "";
	let originalRequest = error.config;
	if(error.code === -27 || error.code === 104 ){
		loginByDeviceID()
		.then((response) => {
			HTTP.set_session(response.data.session_id);
			HTTP.set_device_id(HTTP.get_device_id());

				window.localStorage.setItem("session", response.data.session_id, true);
				window.localStorage.setItem("uid", response.data.profile.uid, true);
				originalRequest.headers['Authorization'] = 'Bearer ' + response.data.session_id;
    HTTP(originalRequest);
				handleError(error)
				// window.sessionStorage.setItemt("error", error.response.data.code);
				throw error;
		})
	}
	// if (error.response && error.response.config) {
	// 	url = error.response.config.url;
	// }

	// let code = getErrorCode(error);

	// let type = getErrorType(code);
	// Events.http_error(code, type, url);
	throw error;
});

HTTP.get_device_id = () => {
	return device;
};

HTTP.set_device_id = (val) => {
	device = val;
	Storage.set("device_id", val, true);
};

HTTP.set_session = (val) => {
	if (Settings.debug_http) {
		console.warn("HTTP.set_session", val);
	}
	session_id = val;
	Storage.set("session", val, true);
};

HTTP.set_qualified_session = (val) => {
	if (Settings.debug_http) {
		console.warn("HTTP.set_session", val);
	}
	qualified_session_id = val;
	Storage.set("session", val, true);
};

HTTP.get_qualified_session = () => {
	return qualified_session_id;
};

export default HTTP;

export { HTTP_other };
